export default function ($translate) {
    return {
        LABELS: {
            NAME: $translate.instant('questionImport.Name'),
            EXTERNAL_ID: $translate.instant('questionImport.External id'),
            DESCRIPTION: $translate.instant('questionImport.Description'),
            HELP: $translate.instant('questionImport.Help text'),
            LEVEL: $translate.instant('questionImport.Level'),
            CATEGORY: $translate.instant('questionImport.Category'),
            POINTS: $translate.instant('questionImport.Max points')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/questions/fields/freeText/index.js